// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__uEyON","blue":"styles_blue__R3Mwr","white":"styles_white__Kf0w_","background":"styles_background__reZ7h"};